import React from "react";

function InputField({
  field,
  form,
  id = "input-field", // Consider making this more unique for multiple fields
  type = "text",
  placeholder = "",
  labelClassName = "",
  inputClassName = "",
  label,
  required = false,
  disabled = false,
  placeholderFontSize = "text-[12px] text-[#B8A7AD]",
  placeholderFontFamily = "bold",
}) {
  return (
    <div>
      {label && (
        <label
          htmlFor={id}
          className={`block mt-6 mb-2 text-[1.2rem] text-[#4F2532] dark:text-[#4F2532] ${labelClassName}`}
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <input
        type={type}
        id={id}
        className={`rounded-[10px] pl-3 block flex-1 font-[medium1] border-[1px] border-[#4F25321A] w-full h-full p-2.5 dark:text-[#4F2532] !text-[#4F2532] placeholder:text-[#B8A7AD] focus-visible:outline-[#EFB6B6] ${placeholderFontSize} focus-visible:outline-none ${inputClassName}`}
        placeholder={placeholder}
        {...field}
        required={required}
        disabled={disabled}
      />
      {form.touched[field.name] && form.errors[field.name] && (
        <div className="text-red-500 text-[12px] mt-2">
          {form.errors[field.name]}
        </div>
      )}
    </div>
  );
}

export default InputField;
